import { render, staticRenderFns } from "./budgetDetail.vue?vue&type=template&id=052e28c9&"
import script from "./budgetDetail.vue?vue&type=script&lang=js&"
export * from "./budgetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports